import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { clientOptionsKeyFieldsMapping } from './createClientStatistics';
import type { ClientStatistic } from '../../common/types/statistics/fbStatistics';

type Props = {
  clientStatistics: ClientStatistic;
};

function OptionStatistics({ clientStatistics }: Props) {
  return (
    <Stack direction='column' spacing={2}>
      {clientOptionsKeyFieldsMapping.map(({ key, fields }) => {
        const statisticByKey = clientStatistics[key];
        const field = fields.find((field) => field.key === key);
        if (field == null || (field.fieldTypes !== 'select' && field.fieldTypes !== 'checkboxSelect')) {
          return null;
        }
        return (
          <Stack key={key}>
            {field.label != null && <Typography fontWeight='bold'>{field.label}</Typography>}
            {Object.keys(statisticByKey).map((statisticKey) => {
              const option = field.options.find((option) => option.value === statisticKey);

              return option == null ? null : (
                <Typography key={statisticKey}>
                  {option.label}: {statisticByKey[statisticKey]}
                </Typography>
              );
            })}
          </Stack>
        );
      })}
    </Stack>
  );
}

export default OptionStatistics;
